// src/pages/VerifyOtpPage.js
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../api";
import logo from "../logo.png";

export default function VerifyOtpPage() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const email = state?.email;

  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (!email) {
    navigate("/login", { replace: true });
    return null;
  }

  const verify = async () => {
    if (!otp) {
      setError("Please enter the OTP.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      const res = await api.post("/auth/api/employee/otp/verify", {
        email,
        otp,
      });
      localStorage.setItem("accessToken", res.data.data.accessToken);
      localStorage.setItem("refreshToken", res.data.data.refreshToken);
      navigate("/limits");
    } catch (err) {
      setError(err.response?.data?.message || "Invalid OTP.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <img src={logo} alt="Logo" className="header-logo" />
      <h2>Verify OTP</h2>
      <p style={{ textAlign: "center" }}>
        We sent an OTP to <strong>{email}</strong>
      </p>

      <div className="form-group">
        <input
          type="text"
          placeholder="Enter OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
        />
      </div>

      <button onClick={verify} disabled={loading}>
        {loading ? "Verifying…" : "Verify"}
      </button>

      {error && <p className="error-message">{error}</p>}
    </div>
  );
}
